// Light Prism theme tuned to the melonai cream/paper + green palette.
// Reuses brand accents already used elsewhere on the site
// (purple #7E22CE, magenta #BE185D, amber #B45309, deep green #15803D).
export const melonPrismTheme = {
  'code[class*="language-"]': {
    color: "#0A0A0A",
    background: "transparent",
    fontFamily: '"Space Mono", "JetBrains Mono", monospace',
    fontSize: "0.82rem",
    lineHeight: "1.65",
    direction: "ltr",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    tabSize: 2,
    hyphens: "none",
  },
  'pre[class*="language-"]': {
    color: "#0A0A0A",
    background: "#FFFFFF",
    fontFamily: '"Space Mono", "JetBrains Mono", monospace',
    fontSize: "0.82rem",
    lineHeight: "1.65",
    padding: "1rem 1.25rem",
    margin: "1.5rem 0",
    overflow: "auto",
    border: "2px solid #D4D4D4",
    borderRadius: "0",
    boxShadow: "4px 4px 0px 0px #15803D",
  },
  comment: { color: "#0A0A0A", opacity: 0.45, fontStyle: "italic" },
  prolog: { color: "#0A0A0A", opacity: 0.45 },
  doctype: { color: "#0A0A0A", opacity: 0.45 },
  cdata: { color: "#0A0A0A", opacity: 0.45 },
  punctuation: { color: "#0A0A0A", opacity: 0.7 },
  property: { color: "#7E22CE" },
  tag: { color: "#15803D" },
  boolean: { color: "#B45309" },
  number: { color: "#B45309" },
  constant: { color: "#B45309" },
  symbol: { color: "#B45309" },
  deleted: { color: "#DC2626" },
  selector: { color: "#7E22CE" },
  "attr-name": { color: "#7E22CE" },
  string: { color: "#7E22CE" },
  char: { color: "#7E22CE" },
  builtin: { color: "#15803D", fontWeight: "700" },
  inserted: { color: "#15803D" },
  operator: { color: "#0A0A0A" },
  entity: { color: "#0A0A0A", cursor: "help" },
  url: { color: "#15803D" },
  ".language-css .token.string": { color: "#7E22CE" },
  ".style .token.string": { color: "#7E22CE" },
  variable: { color: "#0A0A0A" },
  atrule: { color: "#15803D" },
  "attr-value": { color: "#7E22CE" },
  function: { color: "#BE185D" },
  "class-name": { color: "#15803D", fontWeight: "700" },
  keyword: { color: "#15803D", fontWeight: "700" },
  regex: { color: "#B45309" },
  important: { color: "#DC2626", fontWeight: "700" },
  bold: { fontWeight: "700" },
  italic: { fontStyle: "italic" },
};
